import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: 100,
  },
})
